require('common');

function initPage(){
	initForm();
	initTab();
}

function initTab(){
	$('.btn-tab').on('click',function(){
		let $btn = $(this);

		let show = $btn.data('show');
		switch(show){

			case 'map':
				$('.counsellor-tab-map')
				.addClass('full')
				.show();
				$('.counsellor-tab-table').hide();


                setTimeout(
                    function(){
                        fitMapBounds();
                    },
                    1000
                );
			break;

			case 'table':
				$('.counsellor-tab-map').hide();
				$('.counsellor-tab-table')
				.addClass('full')
				.show();
			break;

			case 'all':
				$('.counsellor-tab-map')
				.removeClass('full')
				.show();
				$('.counsellor-tab-table')
				.removeClass('full')
				.show();

                setTimeout(
                    function(){
                        fitMapBounds();
                    },
                    1000
                );
			break;
		}
		$('.btn-tab').removeClass('active');
		$btn.addClass('active');
	});

	$('.btn-tab.active').trigger('click');
}

function initForm(){
	let $locationInput = $('.counsellor-search-input-location');
	$locationInput.hide();
	$locationInput.select2({
        ajax: {
            url: '/location-search',
            type: 'GET',
            dataType: 'json',
            delay: 500,
            data: function (params) {
                return {
                    'q': params.term, // search term
                    'page': params.page,
                    'page_limit': 30,
                    'mode': 'counsellor',
                };
            },
            processResults: function (data, params) {
                var results = [];
                $.each(data.items,function(key,item){
                    if(item.slug && item.label){
                        results.push({
                            id: item.slug,
                            text: item.label
                        });
                    }
                });

                var size = data.totalCount;
                var page = params.page;
                if(!page){
                    page = 1;
                }
                var more = (page * 30) < size;
                return {
                    results: results,
                    pagination: {
                        more: more
                    }
                };
            },
        },
        placeholder: 'Lieu',
        escapeMarkup: function (markup) {
            return markup;
        },
        minimumInputLength: 2,
        width: 'style',
        multiple: true,
        maximumSelectionLength: 1,
        dropdownAutoWidth : true
    });

	$locationInput.on('change',function(){
        var closestPropTypes = $(this).closest('.input-location');
        var input = $('.select2-search__field', closestPropTypes);
        var placeHolder = $(this).data('placeholder');
        if(!placeHolder){
            placeHolder = 'Lieu';
        }

        setTimeout(
            function(){
                input.attr('placeHolder', placeHolder);
            },
            100
        );
    });
    $locationInput.trigger('change');


    let $form = $('.counsellor-search-form');

    $form.on("submit",function(event){
        event.preventDefault();
        event.stopPropagation();


        let $totalContainer = $('.counsellor-total');
        let $tabContainer = $('.counsellor-tab-container');
        let $menuContainer = $('.tab-list');
        let $listTitle = $('.counsellor-content-title');

        $listTitle.html('').append($listTitle.data('default'));

        $totalContainer
        .html('')
        .append(
            $('<div/>')
            .addClass('loader')
        );

        $tabContainer.hide();
        $menuContainer.hide();

        let $inputName = $('input[name="name"]',$form);
        let $inputLocation = $('select[name="location"]',$form);

        let key = 'COUNSELLOR-SEARCH:[name='+$inputName.val()+"][location="+$inputLocation.val()+"]";
        let xhr = sessionStorage.getItem(key);
        if(xhr){
            xhr = JSON.parse(xhr);
        }
        if(xhr && xhr.success){
            return onCounsellorFormDone(xhr);
        }

        $.ajax({
            'url': $form.attr('action'),
            'method': $form.attr('method'),
            'data': $form.serializeArray()
        })
        .done(function(xhr){
            if(xhr && xhr.success){
                sessionStorage.setItem(key,JSON.stringify(xhr));
            }
            onCounsellorFormDone(xhr);
        })
        .fail(function(){

            let message = "Une erreur est advenue";
            $totalContainer.html('')
            .append(
                $('<div/>')
                .addClass('page-error')
                .append(
                    $('<div/>')
                    .addClass('page-error-info')
                    .append(message)
                )
            );
        })
        .always(function(){
        });
    })


    $form.trigger('submit');
}

// Sets the map on all markers in the array.
function setMapOnAll(map) {
    for (let i = 0; i < markers.length; i++) {
        markers[i].setMap(map);
    }
}

// Removes the markers from the map, but keeps them in the array.
function hideMarkers() {
    setMapOnAll(null);
}

// Shows any markers currently in the array.
function showMarkers() {
    setMapOnAll(map);
}

// Deletes all markers in the array by removing references to them.
function deleteMarkers() {
    hideMarkers();
    markers = [];
}

window.markerCluster = null;
window.bounds = null;

function fillMap(list){
    if(!map){
        document.addEventListener('counsellor-map-initialized',function(){
            fillMap(list);
        });
        return;
    }

    deleteMarkers();
    var marker_iamge = '/web/public/images/marker-specific.png';
    markers = list.map(function(counsellor,i){
        let markerData = {
            'position': counsellor.marker,
            icon: marker_iamge,
            'content': counsellor.html
        };
        return new google.maps.Marker(markerData)
    });

    if(markerCluster){
        markerCluster.clearMarkers();
        markerCluster.addMarkers(markers);
    }else{
        markerCluster = new MarkerClusterer(
            map,
            markers,
            {
                imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
                maxZoom: window.megagenceMaxZoom,
            }
        );
    }

    bounds = new google.maps.LatLngBounds();
    for (var i = 0; i < markers.length; i++) {
        bounds.extend(markers[i].getPosition());

        google.maps.event.addListener(markers[i],'click',function(){
            infowindow.setContent(this.content);
            infowindow.open(map,this);
        });
    }
    fitMapBounds();

}

function fitMapBounds(){
    map.fitBounds(bounds);
    let zoomChangeBoundsListener = google.maps.event.addListenerOnce(map, 'bounds_changed', function(event) {
        if ( this.getZoom() > window.megagenceMaxZoom){   // or set a minimum
            this.setZoom(window.megagenceMaxZoom);  // set zoom here
        }
    });
    setTimeout(function(){google.maps.event.removeListener(zoomChangeBoundsListener)}, 2000);
}

function fillTable(list){

    let $tableContainer = $('.counsellor-table');
    $tableContainer.html('');

    let $list = $('<ul/>')
    .addClass('counsellor-content-row');

    let length  = 15;
    let page = 1;
    let nbItems = 0;
    for(var i in list ){
        let counsellor = list[i];
        nbItems++;

        let $item = $('<li/>')
        .addClass('counsellor-content-col')
        .attr('data-page',page)
        .append(counsellor.html);

        if(nbItems >= length){
            nbItems = 0;
            page++;
        }
        $item.hide();


        $list.append($item);
    }

    $tableContainer.append($list);

    $('.counsellor-content-col[data-page="1"]',$tableContainer).show();

    if(page > 1){
        showPagination(page);
    }
}

function showPagination(nbPages){

    let $tableContainer = $('.counsellor-table');
    let $pagination = $('<div/>')
    .addClass('pagination-content')
    .appendTo($tableContainer);

    let nbShownPerSide = 3;

    let $list = $('<ul/>')
    .addClass('pagination')
    .appendTo($pagination);

    $list
    .append(
        $('<li/>')
        .addClass('disabled')
        .append(
            $('<span/>')
            .attr('data-page','first')
            .addClass('pager-link pager-darrow pager-first')
            .append(
                $('<i/>')
                .addClass('fa fa-angle-double-left')
            )
            .append('&nbsp;')
        )
    )


    $list
    .append(
        $('<li/>')
        .addClass('disabled')
        .append(
            $('<span/>')
            .attr('data-page','previous')
            .addClass('pager-link pager-arrow pager-previous')
            .append(
                $('<i/>')
                .addClass('fa fa-angle-left')
            )
            .append('&nbsp;')
        )
    )


    for(var page = 1; page <= nbPages; page++){
        let $link = $('<span/>')
        .attr('data-page',page)
        .addClass('pager-link pager-page')
        .append(page);

        let $item = $('<li/>')
        .append($link)

        $list
        .append($item);

        if(page == 1){
            $item
            .addClass('active');
        }else if(page <= nbShownPerSide){
            //let $link displayed
        }else{
            $item.hide();
        }


    }

    $list
    .append(
        $('<li/>')
        .append(
            $('<span/>')
            .attr('data-page','next')
            .addClass('pager-link pager-arrow pager-next')
            .append(
                $('<i/>')
                .addClass('fa fa-angle-right')
            )
            .append('&nbsp;')
        )
    )

    $list
    .append(
        $('<li/>')
        .append(
            $('<span/>')
            .attr('data-page','last')
            .addClass('pager-link pager-darrow pager-last')
            .append(
                $('<i/>')
                .addClass('fa fa-angle-double-right')
            )
            .append('&nbsp;')
        )
    )



    $('.pager-link',$pagination).on('click',function(){
        let $currentLink = $(this);

        let $currentItem = $currentLink.parent();
        let currentPage = $currentLink.data('page');
        let $actualActiveItem = $('.active',$pagination);
        let $actualActive = $('.pager-page',$actualActiveItem);
        let actualPage = $actualActive.data('page');

        if($currentItem.hasClass('disabled') || $currentItem.hasClass('active')){
            //do nothing
            return;
        }

        if(currentPage == 'previous'){
            $('.pager-page[data-page="'+(actualPage-1)+'"]',$pagination).trigger('click');
            return;
        }else if (currentPage == 'next'){
            $('.pager-page[data-page="'+(actualPage+1)+'"]',$pagination).trigger('click');
            return;
        }else if (currentPage == 'first'){
            $('.pager-page[data-page="'+1+'"]',$pagination).trigger('click');
            return;
        }else if (currentPage == 'last'){
            $('.pager-page[data-page="'+nbPages+'"]',$pagination).trigger('click');
            return;
        }

        $('.pager-page',$pagination)
        .parent()
        .hide()
        .removeClass('active');

        $currentItem.addClass('active');

        if(currentPage < nbShownPerSide){
            $('.pager-page[data-page="'+1+'"]',$pagination).parent().show();
            $('.pager-page[data-page="'+2+'"]',$pagination).parent().show();
            $('.pager-page[data-page="'+3+'"]',$pagination).parent().show();
        }else if(currentPage <= (nbPages - nbShownPerSide)){
            $('.pager-page[data-page="'+(currentPage-1)+'"]',$pagination).parent().show();
            $currentItem.show();
            $('.pager-page[data-page="'+(currentPage+1)+'"]',$pagination).parent().show();
        }else{
            $('.pager-page[data-page="'+(nbPages)+'"]',$pagination).parent().show();
            $('.pager-page[data-page="'+(nbPages-1)+'"]',$pagination).parent().show();
            $('.pager-page[data-page="'+(nbPages-2)+'"]',$pagination).parent().show();
        }

        $('.pager-first',$pagination).parent().removeClass('disabled');
        $('.pager-previous',$pagination).parent().removeClass('disabled');
        $('.pager-last',$pagination).parent().removeClass('disabled');
        $('.pager-next',$pagination).parent().removeClass('disabled');

        if(currentPage == 1){
            $('.pager-first',$pagination).parent().addClass('disabled');
            $('.pager-previous',$pagination).parent().addClass('disabled');
        }else if(currentPage == nbPages){
            $('.pager-last',$pagination).parent().addClass('disabled');
            $('.pager-next',$pagination).parent().addClass('disabled');
        }

        $('.counsellor-content-col').hide();
        $('.counsellor-content-col[data-page="'+currentPage+'"]').show();
        $('.counsellor-content-row')[0].scrollTop = 0;
        $('.counsellor-content-header')[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
}


function onCounsellorFormDone(xhr){
    let $totalContainer = $('.counsellor-total');
    let $listTitle = $('.counsellor-content-title');
    let $tabContainer = $('.counsellor-tab-container');
    let $menuContainer = $('.tab-list');


    $listTitle.html('').append($listTitle.data('default'));

    $totalContainer.html('');
    
    if(xhr.success){

        let total = xhr.total;

        if(total > 0 && xhr.extended){
            let classPrestige = '';
            if($totalContainer.hasClass('prestige')){
                classPrestige = 'prestige-h3';
            }
            $listTitle
            .html('')
            .append('Aucun résultat ne correspond à votre recherche.<br/>La recherche a donc été élargie.');
        }

        if(total > 0){
            let totalMessage = total + ' consultant';
            if(total > 1){
                totalMessage += 's';
            }
            $totalContainer.append(totalMessage);

            $tabContainer.show();
            $menuContainer.show();
            fillMap(xhr.data);
            fillTable(xhr.data);
        }else{

            $listTitle
            .html('')
            .append('Aucun résultat ne correspond à votre recherche.');
        }
    }else{
        let message = "Une erreur est advenue";
        if(xhr.message){
            message = xhr.message;
        }
        $listTitle.html('')
        .append(message);
    }
}


$(document).ready(function(){
	initPage();
});
